'use client';

import { c as _c } from "react/compiler-runtime";
import { GoogleTagManager } from '@next/third-parties/google';
import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { isOpenFinanceCallbackPath } from '@/lib/open-finance/consent-callback-handoff';
const CLARITY_PROJECT_ID = 'tb62p0btqk';
function loadProductAnalytics() {
  const win = window as any;
  win.RudderSnippetVersion = '3.2.0';
  const identifier = 'rudderanalytics';
  if (!Array.isArray(win[identifier])) {
    win[identifier] = [];
  }
  const rudderanalytics = win[identifier] as Array<unknown> & {
    snippetExecuted?: boolean;
    [key: string]: unknown;
  };
  if (rudderanalytics.snippetExecuted !== true) {
    rudderanalytics.snippetExecuted = true;
    win.rudderAnalyticsBuildType = 'legacy';
    const methods = ['setDefaultInstanceKey', 'load', 'ready', 'page', 'track', 'identify', 'alias', 'group', 'reset', 'setAnonymousId', 'startSession', 'endSession', 'consent', 'addCustomIntegration'] as const;
    for (const method of methods) {
      rudderanalytics[method] = (...args: unknown[]) => {
        if (Array.isArray(win[identifier])) {
          rudderanalytics.push([method, ...args]);
          return;
        }
        const current = win[identifier] as Record<string, unknown>;
        const fn = current[method];
        if (typeof fn === 'function') {
          fn(...args);
        }
      };
    }
  }
  const hasClarityScript = document.querySelector(`script[data-clarity-id="${CLARITY_PROJECT_ID}"]`);
  if (!hasClarityScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
    script.setAttribute('data-clarity-id', CLARITY_PROJECT_ID);
    document.head.appendChild(script);
  }
}
export function AnalyticsBootstrap() {
  const $ = _c(6);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = isOpenFinanceCallbackPath(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const skipThirdParty = t0;
  let t1;
  let t2;
  if ($[2] !== skipThirdParty) {
    t1 = () => {
      if (skipThirdParty) {
        return;
      }
      loadProductAnalytics();
    };
    t2 = [skipThirdParty];
    $[2] = skipThirdParty;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (skipThirdParty) {
    return null;
  }
  const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{gtmId ? <GoogleTagManager gtmId={gtmId} /> : null}<Analytics /><SpeedInsights /></>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}